<template>
    <div class="md-detail-info classic" :style="{ marginBottom }">
        <DetailBanner
            :listingDetail="listingDetail"
            :apptTitle="apptTitle"
            :apptSubTitle="apptSubTitle"
            :apptSubmitText="apptSubmitText"
            :apptQuestionMsg="apptQuestionMsg"
        ></DetailBanner>
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            ref="detailInfo"
        >
            <div
                class="detail-info-right"
                ref="right"
                v-if="!isMobileSize && info.listingStatus != 'Sold'"
            >
                <Schedule
                    ref="schedule"
                    :apptTitle="apptTitle"
                    :apptSubTitle="apptSubTitle"
                    :apptSubmitText="apptSubmitText"
                    :apptQuestionMsg="apptQuestionMsg"
                ></Schedule>
            </div>
            <DetailInfo
                ref="container"
                :class="{ 'detail-info-left': info.listingStatus != 'Sold' }"
                :positionProvided="positionProvided"
                @readMore="onScroll()"
            ></DetailInfo>
        </module-box>
        <BottomMenu
            ref="mobileBottomMenu"
            v-if="isMobileSize"
            theme="classic"
        ></BottomMenu>
        <house-mask v-if="isShowMask" theme="classic" />
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </div>
</template>

<script>
import Common from '../index';
import Schedule from '../schedule.vue';
import DetailInfo from './detail-info.vue';
import global from '../../../common/global';
import DetailBanner from './banner.vue';
import BottomMenu from '../bottom-menu.vue';
import HouseMask from '../mask.vue';
export default {
    components: {
        Schedule,
        DetailInfo,
        DetailBanner,
        BottomMenu,
        HouseMask
    },
    mixins: [Common],
    data: function() {
        return {
            leaveMsgTheme: 'template1',
            theme: 'classic',
            styleTheme: 'classic'
        };
    },
    provide() {
        return {
            sharePop: this.sharePop,
        };
    },
    computed: {
        _baseTheme() {
            return 'classic';
        }
    },
    // watch: {
    //     isMobileSize(val) {
    //         if (!val) {
    //             this.onScroll();
    //         }
    //     }
    // },
    created() {},
    mounted() {
        this.initScroll();
    },
    unmounted() {
        this.destroyScroll();
    },
    methods: {
        scrollIntoSchedule() {
            if (this.$refs.schedule) {
                this.$refs.schedule.$el.scrollIntoView();
            }
        },
        initScroll() {
            if (this.$refs.right) {
                this.headerHeight = 100; //md-detail-info banner sticky bar
                global.scroll(this.onScroll);
            }
        },
        destroyScroll() {
            global.scroll(this.onScroll, true);
        },
        onScroll() {
            if (this.isMobileSize) {
                return; 
            }
            let right = this.$refs.right;
            if (!right) {
                return; 
            }

            if (this.$refs.container.$el.offsetHeight <= right.offsetHeight) {
                if (this.status == 'unactive') {
                    return;
                }
                right.style.position = 'static';
                this.status = 'unactive';
                return;
            }
            let containerRect =
                this.$refs.container.$el.getBoundingClientRect();
            let rightRect = right.getBoundingClientRect();

            if (containerRect.top > this.headerHeight) {
                if (this.status == 'normal') {
                    return; 
                }
                right.style.position = 'static';
                this.status = 'normal';
                return;
            }
            if (containerRect.top <= this.headerHeight) {
                if (
                    containerRect.bottom >
                    this.headerHeight + right.offsetHeight
                ) {
                    if (this.status == 'fixed') {
                        return; 
                    }
                    right.style.position = 'fixed';
                    right.style.left = rightRect.left + 'px';
                    right.style.top = this.headerHeight + 'px';
                    right.style.bottom = 'auto';
                    right.style.zIndex = 100;
                    this.status = 'fixed';
                } else {
                    if (this.status == 'bottom') {
                        return; 
                    }
                    right.style.position = 'absolute';
                    right.style.left = 'auto';
                    right.style.right = '0px';
                    right.style.bottom = '0px';
                    right.style.top = 'auto';
                    this.status = 'bottom';
                }
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
$right-width: 350px;
.md-detail-info.classic {
    width: 100%;
    position: relative;
    .listing-detail-banner {
        margin-bottom: 30px;
        @media (max-width: 800px) {
            margin-bottom: 0;
        }
    }
    .mg-container:not(.breadcrumb-bar) {
        position: relative;
        overflow: visible;
        &:after {
            content: '';
            display: block;
            clear: both;
        }
    }
    .detail-info-right {
        width: $right-width;
        float: right;
    }
    .detail-info-left {
        float: left;
        width: calc(100% - #{$right-width});
        padding-right: 40px;
    }
    @include media-1080 {
        .mg-container {
            > .listingdetail-share {
                display: none;
            }
        }
    }
    @include media-800 {
        margin-top: 0px;
        .detail-info-right {
            display: none;
        }
        .detail-info-left {
            width: 100%;
            padding-right: 0px;
        }
    }
}
</style>
